class CartDrawer extends DrawerComponent {
  constructor() {
    super();
    window.FoxKitSections = FoxTheme.utils.getSectionId(this);

    this.onCartRefreshListener = this.onCartRefresh.bind(this);
    this.getSectionToRenderListener = this.getSectionToRender.bind(this);
  }

  get requiresBodyAppended() {
    return false;
  }

  get sectionId() {
    return this.getAttribute('data-section-id');
  }

  connectedCallback() {
    super.connectedCallback();

    document.addEventListener('cart:grouped-sections', this.getSectionToRenderListener);
    document.addEventListener('cart:refresh', this.onCartRefreshListener);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener('cart:grouped-sections', this.getSectionToRenderListener);
    document.removeEventListener('cart:refresh', this.onCartRefreshListener);
  }

  getSectionToRender(event) {
    event.detail.sections.push(FoxTheme.utils.getSectionId(this));
  }

  show(focusElement = null, animate = true) {
    super.show(focusElement, animate);

    if (this.open) {
      FoxTheme.a11y.trapFocus(this, this.focusElement);
    }
  }

  async onCartRefresh(event) {
    const cartId = `CartDrawer-${this.sectionId}`;

    const cartElement = document.getElementById(cartId);
    if (!cartElement) return;

    try {
      const response = await fetch(`${FoxTheme.routes.root_url}?section_id=${this.sectionId}`);
      const responseText = await response.text();

      const parser = new DOMParser();
      const parsedHTML = parser.parseFromString(responseText, 'text/html');

      const newCartContent = parsedHTML.getElementById(cartId).innerHTML;
      cartElement.innerHTML = newCartContent;

      if (event.detail.open === true) {
        this.show();
      }
    } catch (error) {
      console.error('Error refreshing cart:', error);
    }
  }
}
customElements.define('cart-drawer', CartDrawer);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', FoxTheme.utils.debounce(this.onChange.bind(this), 300));
    this.cartUpdateUnsubscriber = FoxTheme.pubsub.subscribe(
      FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
      this.onCartUpdate.bind(this)
    );

    this.cartItemProducts = this.querySelectorAll('.cart-item__product');
    this.cartItemQuantitys = this.querySelectorAll('.cart-item__quantity');

    const loadTemplateContent = (elements, parentSelector) => {
      elements.forEach((element) => {
        const template = element.querySelector('template');
        const templateContent = template && document.importNode(template.content, true);
        const parent = element.querySelector(parentSelector);

        if (parent && template && !parent.querySelector('.template-content')) {
          const contentWrapper = document.createElement('div');
          contentWrapper.classList.add('template-content', 'w-full');
          contentWrapper.appendChild(templateContent);
          parent.appendChild(contentWrapper);
        }
      });
    };

    const removeTemplateContent = (elements, parentSelector) => {
      elements.forEach((element) => {
        const parent = element.querySelector(parentSelector);
        const templateContent = parent?.querySelector('.template-content');

        if (templateContent) {
          parent.removeChild(templateContent);
        }
      });
    };

    const handleTabletMatch = () => {
      loadTemplateContent(this.cartItemProducts, '.cart-item__product--info');
      removeTemplateContent(this.cartItemQuantitys, '.cart-item__quantity-wrapper');
    };

    const handleTabletUnmatch = () => {
      removeTemplateContent(this.cartItemProducts, '.cart-item__product--info');
      loadTemplateContent(this.cartItemQuantitys, '.cart-item__quantity-wrapper');
    };

    const mqlTablet = window.matchMedia(FoxTheme.config.mediaQueryTablet);
    FoxTheme.config.mqlTablet = mqlTablet.matches;

    if (FoxTheme.config.mqlTablet) {
      handleTabletMatch();
    } else {
      handleTabletUnmatch();
    }

    mqlTablet.onchange = (event) => {
      if (event.matches) {
        handleTabletMatch();
      } else {
        FoxTheme.config.mqlTablet = false;
        handleTabletUnmatch();
      }
    };

    window.FoxKitSections = FoxTheme.utils.getSectionId(this);
  }

  cartUpdateUnsubscriber = undefined;

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  setValidity(target, message) {
    target.setCustomValidity(message);
    target.reportValidity();
    target.value = target.defaultValue;
    target.select();
  }

  validateQuantity(event) {
    const target = event.target;
    const inputValue = parseInt(target.value);
    const index = target.getAttribute('data-index');
    let message = '';

    if (inputValue < parseInt(target.getAttribute('data-min'))) {
      message = FoxTheme.quickOrderListStrings.min_error.replace('[min]', target.getAttribute('data-min'));
    } else if (inputValue > parseInt(target.max)) {
      message = FoxTheme.quickOrderListStrings.max_error.replace('[max]', target.max);
    } else if (inputValue % parseInt(target.step) !== 0) {
      message = FoxTheme.quickOrderListStrings.step_error.replace('[step]', target.step);
    }

    if (message) {
      this.setValidity(target, message);
    } else {
      target.setCustomValidity('');
      target.reportValidity();
      this.updateQuantity(index, inputValue, document.activeElement.getAttribute('name'), target);
    }
  }

  onCartUpdate(event) {
    if (event.cart.errors) {
      this.onCartError(event.cart.errors, event.target);
      return;
    }

    const sectionId = FoxTheme.utils.getSectionId(this);
    const sectionToRender = new DOMParser().parseFromString(event.cart.sections[sectionId], 'text/html');

    const cartDrawer = document.querySelector(`#CartDrawer-${sectionId}`);
    const cartDrawerBody = document.querySelector(`#CartDrawerBody-${sectionId}`);
    const cartDrawerFooter = document.querySelector(`#CartDrawerFooter-${sectionId}`);
    const cartDrawerEmpty = document.querySelector(`#CartDrawerEmpty-${sectionId}`);
    if (cartDrawer) {
      // const updatedElement = sectionToRender.querySelector(`#CartDrawer-${sectionId}`);
      // if (updatedElement) {
      //   cartDrawer.innerHTML = updatedElement.innerHTML;
      // }
      const cartDrawerBodyUpdate = sectionToRender.querySelector(`#CartDrawerBody-${sectionId}`);
      const cartDrawerFooterUpdate = sectionToRender.querySelector(`#CartDrawerFooter-${sectionId}`);
      const cartDrawerEmptyUpdate = sectionToRender.querySelector(`#CartDrawerEmpty-${sectionId}`);

      if (cartDrawerBodyUpdate) {
        cartDrawerBody.innerHTML = cartDrawerBodyUpdate.innerHTML;
      }
      if (cartDrawerFooterUpdate) {
        cartDrawerFooter.innerHTML = cartDrawerFooterUpdate.innerHTML;
      }

      if (cartDrawerEmptyUpdate) {
        cartDrawerEmpty.innerHTML = cartDrawerEmptyUpdate.innerHTML;
      }

      if (event.cart.item_count > 0) {
        cartDrawerBody.classList.remove('hidden');
        cartDrawerFooter.classList.remove('hidden');
        cartDrawerEmpty.classList.add('hidden');
      } else {
        cartDrawerBody.classList.add('hidden');
        cartDrawerFooter.classList.add('hidden');
        cartDrawerEmpty.classList.remove('hidden');
      }
    }

    const mainCart = document.querySelector(`#MainCart-${sectionId}`);
    if (mainCart) {
      const updatedElement = sectionToRender.querySelector(`#MainCart-${sectionId}`);
      if (updatedElement) {
        mainCart.innerHTML = updatedElement.innerHTML;
      } else {
        mainCart.closest('.cart').classList.add('is-empty');
        mainCart.remove();
      }
    }

    const lineItem =
      document.getElementById(`CartItem-${event.line}`) || document.getElementById(`CartDrawer-Item-${event.line}`);

    if (lineItem && lineItem.querySelector(`[name="${event.name}"]`)) {
      FoxTheme.a11y.trapFocus(mainCart || cartDrawer, lineItem.querySelector(`[name="${event.name}"]`));
    } else if (event.cart.item_count === 0) {
      cartDrawer
        ? FoxTheme.a11y.trapFocus(cartDrawer, cartDrawer.querySelector('a'))
        : FoxTheme.a11y.trapFocus(document.querySelector('.cart__empty'), document.querySelector('a'));
    } else {
      cartDrawer
        ? FoxTheme.a11y.trapFocus(cartDrawer, cartDrawer.querySelector('.cart-item__title'))
        : FoxTheme.a11y.trapFocus(mainCart, mainCart.querySelector('.cart-item__title'));
    }

    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        detail: {
          cart: event.cart,
        },
      })
    );
  }

  onCartError(errors, target) {
    if (target) {
      this.updateQuantity(
        target.getAttribute('data-index'),
        target.defaultValue,
        document.activeElement.getAttribute('name'),
        target
      );
    } else {
      window.location.href = FoxTheme.routes.cart_url;
    }

    alert(errors);
  }

  updateQuantity(line, quantity, name, target) {
    this.showLoader(line);

    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
    );

    const body = JSON.stringify({
      line,
      quantity,
      sections: sectionsToBundle,
    });

    fetch(`${FoxTheme.routes.cart_change_url}`, { ...FoxTheme.utils.fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((parsedState) => {
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
          sources: 'cart-items',
          cart: parsedState,
          target,
          line,
          name,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  showLoader(line) {
    const sectionId = FoxTheme.utils.getSectionId(this);
    const loaders = document.querySelectorAll(`#Loader-${sectionId}-${line}`);
    if (loaders) {
      loaders.forEach((loader) => {
        loader.classList.add('btn--loading');
      });
    }
  }
}

customElements.define('cart-items', CartItems);

class CartRemoveItem extends HTMLAnchorElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();

      const cartItems = this.closest('cart-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define('cart-remove-item', CartRemoveItem, { extends: 'a' });

class CartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', FoxTheme.utils.debounce(this.onChange.bind(this), 300));

    if (this.button && this.cartNoteDetailsSummary) {
      this.button.addEventListener('click', () => {
        this.cartNoteDetailsSummary.close();
      });
    }
  }

  get cartNoteDetailsSummary() {
    return this.closest('[is="accordion-details"]');
  }

  get button() {
    return this.querySelector('[type="button"]');
  }

  onChange(event) {
    const body = JSON.stringify({ note: event.target.value });
    fetch(`${FoxTheme.routes.cart_update_url}`, { ...FoxTheme.utils.fetchConfig(), ...{ body } });
  }
}
customElements.define('cart-note', CartNote);

class CalculateShipping extends ModalComponent {
  constructor() {
    super();
    this.countryProvince = this.querySelector('country-province');
    this.isCountrySetup = false;
  }
  static get observedAttributes() {
    return [...super.observedAttributes, 'data-show'];
  }
  show() {
    super.show();
    this.setAttribute('data-show', true);
  }

  hide() {
    super.hide();
    this.setAttribute('data-show', false);
  }

  attributeChangedCallback(name, oldValue, newValue) {
    super.attributeChangedCallback(name, oldValue, newValue);
    if (name === 'data-show' && newValue === 'true' && !this.isCountrySetup && this.countryProvince) {
      const template = this.countryProvince.querySelector('template');
      const templateContent = document.importNode(template.content, true);
      this.countryProvince.countryElement.appendChild(templateContent);
      this.countryProvince.init();
      this.isCountrySetup = true;
    }
  }
}
customElements.define('calculate-shipping', CalculateShipping);
class CountryProvinceForm extends HTMLElement {
  constructor() {
    super();
    this.provinceElement = this.querySelector('[name="address[province]"]');
    this.countryElement = this.querySelector('[name="address[country]"]');
    this.template = this.dataset.template;
    this.countryElement.addEventListener('change', this.handleCountryChange.bind(this));
    if (this.template && this.template === 'cart') {
      this.init();
    }
  }

  init() {
    if (this.getAttribute('country') !== '') {
      this.countryElement.selectedIndex = Math.max(
        0,
        Array.from(this.countryElement.options).findIndex((option) => option.textContent === this.dataset.country)
      );
      this.countryElement.dispatchEvent(new Event('change'));
    } else {
      this.handleCountryChange();
    }
  }

  handleCountryChange() {
    const option = this.countryElement.options[this.countryElement.selectedIndex],
      provinces = JSON.parse(option.dataset.provinces);

    this.provinceElement.closest('.form-field').hidden = provinces.length === 0;

    if (provinces.length === 0) {
      return;
    }

    this.provinceElement.innerHTML = '';

    provinces.forEach((data) => {
      const selected = data[1] === this.dataset.province;
      this.provinceElement.options.add(new Option(data[1], data[0], selected, selected));
    });
  }
}
customElements.define('country-province', CountryProvinceForm);

class ShippingCalculator extends HTMLFormElement {
  constructor() {
    super();

    this.submitButton = this.querySelector('[type="submit"]');
    this.resultsElement = this.lastElementChild;

    this.submitButton.addEventListener('click', this.handleFormSubmit.bind(this));
  }

  handleFormSubmit(event) {
    event.preventDefault();

    const zip = this.querySelector('[name="address[zip]"]').value,
      country = this.querySelector('[name="address[country]"]').value,
      province = this.querySelector('[name="address[province]"]').value;

    this.submitButton.classList.add('btn--loading');

    const body = JSON.stringify({
      shipping_address: { zip, country, province },
    });
    let sectionUrl = `${FoxTheme.routes.cart_url}/shipping_rates.json`;

    sectionUrl = sectionUrl.replace('//', '/');

    fetch(sectionUrl, { ...FoxTheme.utils.fetchConfig('javascript'), ...{ body } })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.shipping_rates) {
          this.formatShippingRates(parsedState.shipping_rates);
        } else {
          this.formatError(parsedState);
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.resultsElement.hidden = false;
        this.submitButton.classList.remove('btn--loading');
      });
  }

  formatError(errors) {
    const shippingRatesList = Object.keys(errors).map((errorKey) => {
      return `<li>${errors[errorKey]}</li>`;
    });
    this.resultsElement.innerHTML = `
      <div class="alert alert--error blocks-radius grid gap-2">
        <p class="font-body-bolder m-0">${FoxTheme.shippingCalculatorStrings.error}</p>
        <ul class="list-disc grid gap-1 text-sm" role="list">${shippingRatesList.join('')}</ul>
      </div>
    `;
  }

  formatShippingRates(shippingRates) {
    const shippingRatesList = shippingRates.map(({ presentment_name, currency, price }) => {
      return `<li>${presentment_name}: ${currency} ${price}</li>`;
    });
    this.resultsElement.innerHTML = `
      <div class="alert blocks-radius alert--${
        shippingRates.length === 0 ? 'error' : 'success'
      } grid gap-2 leading-tight">
        <p class="font-body-bolder m-0">${
          shippingRates.length === 0
            ? FoxTheme.shippingCalculatorStrings.notFound
            : shippingRates.length === 1
            ? FoxTheme.shippingCalculatorStrings.oneResult
            : FoxTheme.shippingCalculatorStrings.multipleResults
        }</p>
        ${
          shippingRatesList === ''
            ? ''
            : `<ul class="list-disc grid gap-1 text-sm" role="list">${shippingRatesList.join('')}</ul>`
        }
      </div>
    `;
  }
}
customElements.define('shipping-calculator', ShippingCalculator, { extends: 'form' });

// class CartDrawerProductsRecommendation extends HTMLElement {
//   constructor() {
//     super();
//     if ('requestIdleCallback' in window) {
//       requestIdleCallback(this.init.bind(this), { timeout: 1500 });
//     } else {
//       const userAgent = navigator.userAgent;
//       const isSafari = userAgent.includes('Safari') && !userAgent.includes('Chrome');
//       if (isSafari) {
//         this.init();
//       } else {
//         FoxTheme.Motion.inView(this, this.init.bind(this), { margin: '600px 0px 600px 0px' });
//       }
//     }
//   }

//   get slideContainer() {
//     return this.querySelector('.swiper');
//   }

//   get sliderPagination() {
//     return this.querySelector('.swiper-pagination');
//   }

//   get sliderNext() {
//     return this.querySelector('.swiper-button-next');
//   }

//   get sliderPrev() {
//     return this.querySelector('.swiper-button-prev');
//   }

//   init() {
//     fetch(this.dataset.url)
//       .then((response) => response.text())
//       .then((responseText) => {
//         const sectionInnerHTML = new DOMParser()
//           .parseFromString(responseText, 'text/html')
//           .querySelector('.shopify-section');

//         if (sectionInnerHTML === null) return;

//         const recommendations = sectionInnerHTML.querySelector('cart-drawer-products-recommendation');
//         if (recommendations && recommendations.innerHTML.trim().length) {
//           const productCount = recommendations.querySelectorAll('.product-card');
//           // document.querySelector('.product-recommendation-cart-new').innerHTML += recommendations.querySelector('.product-card').innerHTML;
//           this.innerHTML = recommendations.innerHTML;
//           // console.log(this.innerHTML);
//           this.initCarousel();
//           if (productCount.length > 0) this.classList.remove('hidden');
//           this.dispatchEvent(new CustomEvent('recommendations:loaded'));
//         } else {
//           this.closest('.shopify-section').remove();
//           this.classList.add('hidden');
//           this.dispatchEvent(new CustomEvent('is-empty'));
//         }
//       })
//       .catch((e) => {
//         console.error(e);
//       });
//   }

//   initCarousel() {
//     this.carousel = new FoxTheme.Carousel(this.slideContainer, {
//       slidesPerView: 1,
//       spaceBetween: 10,
//       loop: false,
//       pagination: {
//         el: this.sliderPagination,
//         type: 'fraction',
//       },
//       navigation: {
//         nextEl: this.sliderNext,
//         prevEl: this.sliderPrev,
//       },
//     });

//     this.carousel && this.carousel.init();
//   }
// }

// customElements.define('cart-drawer-products-recommendation', CartDrawerProductsRecommendation);


class CartDrawerProductsRecommendation extends HTMLElement {
  constructor() {
    super();
    if ('requestIdleCallback' in window) {
      requestIdleCallback(this.init.bind(this), { timeout: 1500 });
    } else {
      const userAgent = navigator.userAgent;
      const isSafari = userAgent.includes('Safari') && !userAgent.includes('Chrome');
      if (isSafari) {
        this.init();
      } else {
        FoxTheme.Motion.inView(this, this.init.bind(this), { margin: '600px 0px 600px 0px' });
      }
    }
  }

  get slideContainer() {
    return this.querySelector('.swiper');
  }

  get sliderPagination() {
    return this.querySelector('.swiper-pagination');
  }

  get sliderNext() {
    return this.querySelector('.swiper-button-next');
  }

  get sliderPrev() {
    return this.querySelector('.swiper-button-prev');
  }

  async init() {
    try {
      const cart = await fetch('/cart.js').then(res => res.json());
      
      // Clear cache on cart clear
      if (cart.items.length === 0) {
        Object.keys(sessionStorage).forEach((key) => {
          if (key.startsWith('upsell-')) {
            sessionStorage.removeItem(key);
          }
        });
      }
      if (cart.items.length === 0) return;
      
      // Sort cart items by price and pick top 2
      const sortedItems = cart.items.sort((a, b) => b.final_line_price - a.final_line_price);
      const productIds = [...new Set(sortedItems.slice(0, 2).map(item => item.product_id))];
      const limit = 4;
  
      const recommendationRequests = productIds.map(id =>
        fetch(`/recommendations/products?section_id=${this.dataset.sectionId}&product_id=${id}&limit=${limit}&intent=complementary`)
          .then(res => res.text())
          .then(html => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            return doc.querySelectorAll('.product-card');
          })
      );

      // ✅ Build requests with caching
      // const recommendationRequests = productIds.map(async (id) => {
      //   const cacheKey = `upsell-${id}`;
      //   const cached = sessionStorage.getItem(cacheKey);
  
      //   if (cached) {
      //     const doc = new DOMParser().parseFromString(cached, 'text/html');
      //     return Array.from(doc.querySelectorAll('.product-card'));
      //   } else {
      //     const url = `/recommendations/products?section_id=${this.dataset.sectionId}&product_id=${id}&limit=${limit}&intent=complementary`;
      //     const html = await fetch(url).then(res => res.text());
      //     sessionStorage.setItem(cacheKey, html);
      //     const doc = new DOMParser().parseFromString(html, 'text/html');
      //     return Array.from(doc.querySelectorAll('.product-card'));
      //   }
      // });
  
      const allRecommendations = await Promise.all(recommendationRequests);
      
      // List of product IDs to exclude
      var excludedProductIds = ['14805052260677','14805052031301','14805052653893','14819239362885','14819240476997','14819241427269','14819242344773',
                '14819243983173','14996706787653','15003316158789','15003316355397','15005378609477','15095104733509','15093927641413','15093928526149',
                '8590689665349','15291129168197','15291143487813' , '15015673725253', '14803438043461', '14888695529797', '9527502766405'
       ];

      const unique = new Map();
      allRecommendations.flat().forEach(elItem => {
        elItem.forEach(el => {
          const id = el.attributes[1].value;
          if (id && !unique.has(id) && !excludedProductIds.includes(id)) {
              unique.set(id, el);
            }
        });
      });
      
      // console.log(unique);

      // const unique = new Map();
      // allRecommendations.flat().forEach(card => {
      //   const id = card.dataset.productId;
      //   if (id && !unique.has(id)) {
      //     unique.set(id, card);
      //   }
      // });
  
      const swiperWrapper = this.querySelector('.swiper-wrapper');
      swiperWrapper.innerHTML = ''; // Clear existing
  
      unique.forEach(card => {
      const slide = document.createElement('div');
      slide.classList.add('swiper-slide');
      slide.appendChild(card.cloneNode(true));
      swiperWrapper.appendChild(slide);
    });
  
      if (unique.size > 0) {
        this.classList.remove('hidden');
        // this.initCarousel();
        this.dispatchEvent(new CustomEvent('recommendations:loaded'));
      } else {
        this.classList.add('hidden');
        this.dispatchEvent(new CustomEvent('is-empty'));
      }
    } catch (err) {
      console.log('Error loading recommendations:'+ err);
    }
  }


  initCarousel() {
    this.carousel = new FoxTheme.Carousel(this.slideContainer, {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: false,
      grabCursor: false,
      allowTouchMove: true,
      noSwiping: false,
      pagination: {
        el: this.sliderPagination,
        type: 'fraction',
      },
      breakpoints: {
        768: {
          allowTouchMove: false,
          noSwiping: true,
        }
      },
      navigation: {
        nextEl: this.sliderNext,
        prevEl: this.sliderPrev,
      },
    });

    this.carousel && this.carousel.init();
  }
}

customElements.define('cart-drawer-products-recommendation', CartDrawerProductsRecommendation);

class MainCart extends HTMLElement {
  constructor() {
    super();

    document.addEventListener('cart:grouped-sections', this.getSectionToRender.bind(this));
  }

  getSectionToRender(event) {
    event.detail.sections.push(FoxTheme.utils.getSectionId(this));
  }
}
customElements.define('main-cart', MainCart);

class FreeShippingGoal extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      leftToSpend: '[data-left-to-spend]',
    };
    this.goal = Number(this.dataset.minimumAmount) * Number(window.Shopify.currency.rate || 1) || 0;
    this.progress = this.querySelector('progress-bar');
    this.money_format = window.FoxTheme.settings.moneyFormat;
  }

  connectedCallback() {
    this.updateShippingGloal(Number(this.dataset.cartTotal));
    document.addEventListener('cart:updated', (event) => {
      this.updateShippingGloal(event.detail.cart.items_subtotal_price);
    });
  }

  updateShippingGloal(amount) {
    // if (amount > 0) {
    //   this.classList.remove('hidden');
    // } else {
    //   this.classList.add('hidden');
    // }

    this.cartTotal = amount / 100;
    this.goalLeft = this.goal - this.cartTotal;
    this.goalDone = this.goalLeft <= 0;

    // const thresholds = [700];
    const thresholds = [700, 1000];
    const totalPrice = this.cartTotal;

    const calculateProgress = (levels, value) => {
        const lastLevel = levels[levels.length - 1];
        const totalLevels = levels.length;
        let progress = 0;

        if (value >= lastLevel) {
            return 100;
        }

        for (let i = 0; i < levels.length; i++) {
            const current = levels[i];
            if (value < current) {
                const previous = i === 0 ? 0 : levels[i - 1];
                progress += ((value - previous) / (current - previous)) * (100 / totalLevels);
                break;
            }
            progress += 100 / totalLevels;
        }

        return Math.min(progress, 100);
    };

    this.percent = calculateProgress(thresholds, totalPrice);
    
    // console.log(this.percent);

    if (this.percent >= 100) this.percent = 100;

    if (this.cartTotal >= 1000) {
      this.classList.remove('free-gift-2');
      this.classList.add('free-gift');
    } else{
      this.classList.remove('free-gift');
      this.classList.remove('free-gift-2');
    }

    let free_gift_spend = (1000 - this.cartTotal) * 100;
    this.querySelector('.free-gift-left-to strong').innerHTML = FoxTheme.Currency.formatMoney(
      free_gift_spend,
      this.money_format
    );
    // let free_gift_spend_2 = (1400 - this.cartTotal) * 100;
    // this.querySelector('.free-gift-text-1 strong').innerHTML = FoxTheme.Currency.formatMoney(
    //   free_gift_spend_2,
    //   this.money_format
    // );

    if (this.cartTotal >= this.goal) {
      this.progress.style.setProperty('--percent', `${this.percent}%`);
      this.classList.add('free-shipping-goal--done');
      this.progress.dataset.value = this.cartTotal;
      this.progress.dataset.max = this.goal;
    } else {
      let spend = (this.goal - this.cartTotal) * 100;
      this.querySelector(this.selectors.leftToSpend).innerHTML = FoxTheme.Currency.formatMoney(
        spend,
        this.money_format
      );
      this.classList.remove('free-shipping-goal--done');
      this.classList.remove('free-gift', 'free-gift-2');
      this.progress.style.setProperty('--percent', `${this.percent}%`);
      this.progress.dataset.value = this.cartTotal;
      this.progress.dataset.max = this.goal;
    }
  }
}
customElements.define('free-shipping-goal', FreeShippingGoal);

window.FoxKitAddToCart = async (payload) => {
  if (!payload?.properties?.['_FoxKit offer']) return;

  const cartJson = await (
    await fetch(`${FoxTheme.routes.cart_url}`, {
      ...FoxTheme.utils.fetchConfig(),
    })
  ).json();
  cartJson['sections'] = payload['sections'];
  FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });

  document.dispatchEvent(
    new CustomEvent('product-ajax:added', {
      detail: {
        product: payload,
      },
    })
  );
};


$('#CartDrawer').on('click','.cart-drawer-totals-trigger', function () {
  const $trigger = $(this);
  const $wrapper = $('.cart-drawer-pricing-wrapper');
  $wrapper.toggleClass('active');
  
  if ($wrapper.hasClass('active')) {
    $trigger.text('Skjul detaljer');
  } else {
    $trigger.text('Vis detaljer');
  }
});


// document.addEventListener('cart:updated', (event) => {
//   updateCartFreeProductsByProductId();
// });

$('.cart-drawer').on('click','.drawer__close-btn', function () {
  $(this).closest('.cart-drawer').removeAttr('open');
});

// Replace with your actual free product Shopify product ID
// const FREE_PRODUCT_1_PRODUCT_ID = 8590689665349; // 1000 kr goal
// const FREE_PRODUCT_2_PRODUCT_ID = 15093927641413; // 1400 kr goal

// function updateCartFreeProductsByProductId() {
//   fetch('/cart.js')
//     .then(response => response.json())
//     .then(cart => {
//       const total = cart.total_price / 100;
//       const items = cart.items;

//       const removeItems = [];

//       // Find all matching product line items regardless of variant
//       items.forEach(item => {
//         if (total < 1000 && item.product_id === FREE_PRODUCT_1_PRODUCT_ID) {
//           removeItems.push(item.key);
//         }
//         if (total < 1400 && item.product_id === FREE_PRODUCT_2_PRODUCT_ID) {
//           removeItems.push(item.key);
//         }
//       });

//       // Remove all matched items
//       removeItems.forEach(key => {
//         fetch('/cart/change.js', {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify({
//             id: key,
//             quantity: 0,
//           }),
//         }).then(() => {
//           document.dispatchEvent(new CustomEvent('cart:refresh', {
//             bubbles: true, detail: { open: true }
//           }));
//           console.log('Removed free product with key:', key);
//         });
//       });
//     });
// }



